<template>
  <div class="guide">
    <div class="guideTop">
      <img src="@/assets/img/main/logo.png" alt="">
      <h2>系统操作指南</h2>
    </div>
    <div class="guideCon">
      <div>
        <div style="width: 307px;">
          <h2Title title="指南分类"></h2Title>
          <ul class="left-menu">
            <li v-for="(list,i) in dataLists" :key="list.id" :class="{'active':i==listIndex}" @click="change1(i)"><span>{{list.name}}</span>
              <ul v-if="list.children.length>0">
                <li v-for="(child,index) in list.children" :class="{'active':index==childIndex}" :key="child.id"
                    @click="change2(index)">{{child.name}}
                </li>
                <!-- <li class="active">二级分类</li> -->
              </ul>
            </li>
          </ul>
        </div>

      </div>
      <div>
        <h2Title title="指南详情"></h2Title>
        <div class="content" v-html="content" :style="conheight"></div>
      </div>
    </div>
  </div>

</template>

<script>
  import {
    queryOperManual,
    queryOperManualById
  } from "@/api/msg/msg";

  import h2Title from "@/page/statistics/template/title.vue";

  export default {
    name: "guide",
    data() {
      return {
        dataLists: [],
        listIndex: 0,
        childIndex: 0,
        content: '',
        conheight:{
          "height":'',
          "overflow-y":'auto'
        }
      }
    },
    components: {
      h2Title,
    },
    created() {
      this.conheight.height=(window.innerHeight-68-34-40-20)+'px';
      queryOperManual().then(res => {
        this.dataLists = res.data.data;
        //判断是否有子集
        var id = "";
        if (this.dataLists[this.listIndex].children != null && this.dataLists[this.listIndex].children.length > 0) {
          id = this.dataLists[this.listIndex].children[this.childIndex].id;
        } else {
          id = this.dataLists[this.listIndex].id;
        }
        //加载详情
        this.loadContent(id);
      })
    },
    methods: {
      change1(i) {
        this.listIndex = i;
        if (this.dataLists[this.listIndex].content) {
          var id = this.dataLists[this.listIndex].id;
          this.loadContent(id);
        }
      },
      change2(index) {
        this.childIndex = index;
        var id = this.dataLists[this.listIndex].children[this.childIndex].id;
        this.loadContent(id);
      },
      //加载内容
      loadContent(id) {
        queryOperManualById(id).then(res => {
          this.content = res.data.data.content;
        })
      }
    }
  };
</script>

<style scoped>
  .guideTop h2 {
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    height: 37px;
    line-height: 37px;
    position: relative;
    padding-left: 29px;
    margin-left: 25px;
  }

  .guideTop h2:before {
    content: '';
    position: absolute;
    top: 6px;
    width: 1px;
    height: 31px;
    background: rgba(181, 181, 181, 1);
    border-radius: 2px;
    left: 0;
  }

  .guide {
    background: #F8F8F8;
    min-height: 100%;
  }

  .guideTop {
    height: 68px;
    background: #fff;
    box-shadow: 0px 2px 5px 0px rgba(183, 183, 183, 0.15);
    display: flex;
    align-items: center;
    padding-left: 20px;
  }

  .guideCon {
    display: flex;
    margin: 0 10px 10px 20px;
  }

  .guideCon > div:nth-of-type(1) {
    width: 307px;
    margin-right: 10px;
  }

  .guideCon > div:nth-of-type(2) {
    flex-grow: 1;
  }

  .left-menu > li span {
    display: inline-block;
    height: 44px;
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(119, 119, 119, 0.14);
    border-radius: 4px;
    padding-left: 30px;
    box-sizing: border-box;
    line-height: 44px;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    border-left: 9px solid #fff;
    cursor: pointer;
  }

  .left-menu > li.active span {
    border-left: 9px solid rgba(91, 163, 243, 1);
    color: #5BA3F3;

  }

  .left-menu li ul {
    padding: 4px 0;
    display: none;
  }

  .left-menu > li.active ul {
    display: block;
  }

  .left-menu ul li {
    padding-left: 40px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 22px;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 8px;
    cursor: pointer;
  }

  .left-menu > li.active .active {
    color: #5BA3F3;

  }

  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
    border-radius: 4px;
    min-height: 200px;
    padding: 20px;
  }

  .content >>> img {
    width: 100%;
  }
</style>
